module.exports = "<div>\n  <nav class=\"topbar PPred\">\n      <a class=\"navbar-brand pf\" style=\"padding-top: 0px\" (click)=\"goHome()\">\n      </a>\n    <div class=\"user\" *ngIf=\"securityService.isLoggedIn()\">\n      <span class=\"navbar-brand\">{{securityService.authorization.user.partnerName}} – {{securityService.authorization.user.name}}</span>\n      <button class=\"btn butn logoutBtn\" (click)=\"securityService.logout()\">{{'Logout' | translate}}</button>\n    </div>\n    <app-lang-switcher></app-lang-switcher>\n  </nav>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/top-bar/top-bar.component.html
// module id = ./src/app/top-bar/top-bar.component.html
// module chunks = main